import { isBrowser } from "../env";
import { EventManager } from "../utils/event-manager.class";
import { BrowserWSClient } from "./browser-ws";
import { NodejsWSClient } from "./nodejs-ws";

const EMPTY = Object.freeze({});

export const WSClient = class WSClientBuilder {
  constructor(address) {
    this._address = address || "wss://";
    this._path = "/";
    this._connectionTimeout = 30000; // ms
    (this._headers = EMPTY), (this._certification = EMPTY);
    this._withCredentials = false;
    this._reconnect = true;
    this._reconnectDelay = 1000;
    this._reconnectDelayMax = 100;
    this._reconnectMax = 10;
    this._onPing = () => {};
    this._onPong = () => {};
    this._onConnect = () => {};
    this._onDisconnect = () => {};
    this._onError = () => EMPTY;
    this._auth = EMPTY;
    this._events = new EventManager();
  }

  addEventListener(...args) {
    this._events.addEventListener(...args);
    return this;
  }

  header(value) {
    this._headers = value;
    return this;
  }

  path(value) {
    this._path = value;
    return this;
  }

  connectionTimeout(value) {
    this._connectionTimeout = value;
    return this;
  }

  certification(value) {
    this._certification = value;
    return this;
  }

  withCredentials(value) {
    this._withCredentials = value;
    return this;
  }

  auth(value) {
    this._auth = value;
    return this;
  }

  tryReconnect(value) {
    this._reconnect = value;
    return this;
  }

  tryReconnectDelay(value) {
    this._reconnectDelay = value;
    return this;
  }

  tryReconnectDelayMax(value) {
    this._reconnectDelayMax = value;
    return this;
  }

  tryReconnectMax(value) {
    this._reconnectMax = value;
    return this;
  }

  onPing(cb) {
    this._onPing = cb;
    return this;
  }

  onPong(cb) {
    this._onPong = cb;
    return this;
  }

  onConnect(cb) {
    this._onConnect = cb;
    return this;
  }

  onError(cb) {
    this._onError = cb;
    return this;
  }

  onDisconnect(cb) {
    this._onDisconnect = cb;
    return this;
  }

  connect() {
    const options = {
      address: this._address,
      path: this._path,
      headers: this._headers,
      connectionTimeout: this._connectionTimeout,
      certification: this._certification,
      withCredentials: this._withCredentials,
      reconnect: this._reconnect,
      reconnectDelay: this.reconnectDelay,
      reconnectDelayMax: this.reconnectDelayMax,
      reconnectMax: this._reconnectMax,
      auth: this._auth,
      onPing: this._onPing,
      onPong: this._onPong,
      onConnect: this._onConnect,
      onDisconnect: this._onDisconnect,
      onError: this._onError,
      events: this._events,
      forceNew: true,
    };
    if (isBrowser()) {
      return new BrowserWSClient(options).connect();
    } else {
      return new NodejsWSClient(options).connect();
    }
  }
};
